import axios from "axios";


export const http2020 = axios.create({
    baseURL: process.env.REACT_APP_IMAGE_PROCESSING_RRU,
});